module.exports = __webpack_public_path__ + "static/media/TommyHoodGuide.a3c2c022.png";